import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import EnterpriseLayout from "./EnterpriseLayout";
import { EnterpriseLeadForm } from "./components/EnterpriseContact";
import { PRODUCT_MARKS } from "./components/shared";
import { ENTERPRISE_LINKS } from "./enterpriseLinks";

const ENTERPRISE_PRODUCTS = ["RentShield", "RentID", "RentSuccess", "RentDirect"];

export default function EnterpriseGetStarted() {
  return (
    <EnterpriseLayout
      title="Get Started — Rentid Enterprise"
      description="Tell us about your rental operation and the Rentid enterprise team will help you pick the right mobility platform and marketplace APIs."
      path={ENTERPRISE_LINKS.getStarted}
    >
      <div className="mx-auto grid max-w-7xl gap-12 px-4 pt-20 pb-24 sm:px-6 lg:grid-cols-5 lg:gap-16 lg:pt-16">
        <div className="flex flex-col gap-6 lg:sticky lg:top-28 lg:col-span-2 lg:self-start">
          <Link
            to={ENTERPRISE_LINKS.home}
            className="inline-flex items-center gap-2 text-sm font-medium text-muted-foreground transition-colors hover:text-foreground"
          >
            <ArrowLeft className="size-4" aria-hidden="true" />
            Back to Rentid Enterprise
          </Link>
          <h1 className="font-heading text-4xl font-semibold leading-[1.02] tracking-tighter text-foreground text-balance sm:text-[38px]">
            Get started with Rentid Enterprise Solutions
          </h1>
          <ul className="flex max-w-sm items-center justify-between gap-4" aria-label="Rentid Enterprise products">
            {ENTERPRISE_PRODUCTS.map((product) => (
              <li key={product} className="flex">
                <img
                  src={PRODUCT_MARKS[product].src}
                  alt={product}
                  width={PRODUCT_MARKS[product].width}
                  height={PRODUCT_MARKS[product].height}
                  className="h-9 w-auto object-contain"
                />
              </li>
            ))}
          </ul>
          <p className="text-lg leading-relaxed text-muted-foreground">
            Tell us about your operation and our enterprise
            <br className="hidden sm:inline" /> team will help reach back out with the
            <br className="hidden sm:inline" /> next steps. Let&apos;s build something
            <br className="hidden sm:inline" /> great together.
          </p>
        </div>

        <div className="rounded-3xl border border-border bg-card p-6 shadow-sm sm:p-10 lg:col-span-3">
          <EnterpriseLeadForm />
        </div>
      </div>
    </EnterpriseLayout>
  );
}
